export default __webpack_public_path__ + "static/landing-page-9e4a326d9447fcb1da805373a7b6bb5e.png";